const style = {
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  backgroundColor: "#FFFFFF",
  color: "#202020",
  border: "solid 1px #E0E0E0",
  borderRadius: 10,
  padding: 9,
  fontFamily: "Pretendard",
  alignItems: "center"
};

const disabledStyle = {
  cursor: "default",
  backgroundColor: "#D0D0D0",
  color: "#606060"
};

const textStyle = {
  fontSize: 17,
  fontWeight: 600
};

const descriptionStyle = {
  color: "#707070",
  fontSize: 12
};

export function Button(props) {
  return (<>
    <button type="button" style={ { ...style, ...props.style, ...(props.disabled && disabledStyle) } } onClick={ props.onClick } disabled={ props.disabled ?? false }>
      <span style={ props.textStyle ?? textStyle }>{ props.text }</span>
      { props.description && <span style={ descriptionStyle }>{ props.description }</span> }
    </button>
  </>);
}
